class CartDrawer {
  constructor() {
    this.overlay = document.querySelector('[data-cart-drawer-overlay]');
    this.panel = document.querySelector('[data-cart-drawer-panel]');
    this.openBtns = document.querySelectorAll('[data-cart-drawer-open]');
    this.cartContent = document.querySelector('[data-cart-drawer-content]');
    this.cartItems = document.querySelector('[data-cart-items]');
    this.cartEmpty = document.querySelector('[data-cart-empty]');
    this.cartFooter = document.querySelector('[data-cart-footer]');

    this.init();
  }

  init() {
    this.bindEvents();
    this.initTermsValidation();
    this.checkAutoOpen();
  }

  checkAutoOpen() {
    const urlParams = new URLSearchParams(window.location.search);
    const shouldOpenCart = urlParams.get('open_cart');
    const referrer = document.referrer;

    if (shouldOpenCart === 'true' || referrer.includes('/checkout') || referrer.includes('checkout.shopify')) {
      setTimeout(() => {
        this.open();
      }, 300);

      if (shouldOpenCart === 'true') {
        const url = new URL(window.location);
        url.searchParams.delete('open_cart');
        window.history.replaceState({}, '', url);
      }
    }
  }

  initTermsValidation() {
    const termsCheckbox = document.querySelector('[data-cart-terms]');
    const checkoutBtn = document.querySelector('[data-cart-checkout-btn]');

    if (!termsCheckbox || !checkoutBtn) return;

    checkoutBtn.classList.add('btn--disabled');
    checkoutBtn.style.pointerEvents = 'none';
    checkoutBtn.style.opacity = '0.5';

    termsCheckbox.addEventListener('change', async () => {
      if (termsCheckbox.checked) {
        checkoutBtn.classList.remove('btn--disabled');
        checkoutBtn.style.pointerEvents = 'auto';
        checkoutBtn.style.opacity = '1';

        try {
          const now = new Date();
          const day = now.getDate().toString().padStart(2, '0');
          const month = (now.getMonth() + 1).toString().padStart(2, '0');
          const year = now.getFullYear();
          const hours = now.getHours().toString().padStart(2, '0');
          const minutes = now.getMinutes().toString().padStart(2, '0');
          const dateFormatted = `${day}/${month}/${year} à ${hours}:${minutes}`;

          await fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              attributes: {
                'CGV acceptées': 'Oui',
                'Date d\'acceptation': dateFormatted
              }
            })
          });
        } catch (error) {
          console.error('Failed to save CGV acceptance:', error);
        }
      } else {
        checkoutBtn.classList.add('btn--disabled');
        checkoutBtn.style.pointerEvents = 'none';
        checkoutBtn.style.opacity = '0.5';
      }
    });

    checkoutBtn.addEventListener('click', (e) => {
      if (!termsCheckbox.checked) {
        e.preventDefault();
        if (window.notyf) {
          window.notyf.error('Veuillez accepter les Conditions Générales de Vente pour continuer.');
        } else {
          alert('Veuillez accepter les Conditions Générales de Vente pour continuer.');
        }
      }
    });
  }

  bindEvents() {
    if (this.openBtns.length > 0) {
      this.openBtns.forEach(btn => {
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          this.open();
        });
      });
    }

    document.addEventListener('click', (e) => {
      if (e.target.closest('[data-cart-drawer-close]')) {
        this.close();
      }
    });

    if (this.overlay) {
      this.overlay.addEventListener('click', (e) => {
        if (e.target === this.overlay) {
          this.close();
        }
      });
    }

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.overlay && this.overlay.classList.contains('overlay--active')) {
        this.close();
      }
    });

    this.cartContent.addEventListener('click', (e) => {
      const increaseBtn = e.target.closest('[data-quantity-increase]');
      const decreaseBtn = e.target.closest('[data-quantity-decrease]');
      const removeBtn = e.target.closest('[data-item-remove]');

      if (increaseBtn) {
        const itemKey = increaseBtn.dataset.itemKey;
        const input = this.cartContent.querySelector(`[data-quantity-input][data-item-key="${itemKey}"]`);
        const newQty = parseInt(input.value) + 1;
        this.updateQuantity(itemKey, newQty);
      }

      if (decreaseBtn) {
        const itemKey = decreaseBtn.dataset.itemKey;
        const input = this.cartContent.querySelector(`[data-quantity-input][data-item-key="${itemKey}"]`);
        const newQty = Math.max(0, parseInt(input.value) - 1);
        this.updateQuantity(itemKey, newQty);
      }

      if (removeBtn) {
        const itemKey = removeBtn.dataset.itemKey;
        this.updateQuantity(itemKey, 0);
      }
    });

    this.cartContent.addEventListener('change', (e) => {
      const input = e.target.closest('[data-quantity-input]');
      if (input) {
        const itemKey = input.dataset.itemKey;
        const newQty = Math.max(0, parseInt(input.value) || 0);
        this.updateQuantity(itemKey, newQty);
      }
    });

    document.addEventListener('cart:item-added', () => {
      this.refreshCart();
      this.open();
    });
  }

  open() {
    if (this.overlay) this.overlay.classList.add('overlay--active');
    if (this.panel) this.panel.classList.add('panel--active');
    document.body.style.overflow = 'hidden';
  }

  close() {
    if (this.overlay) this.overlay.classList.remove('overlay--active');
    if (this.panel) this.panel.classList.remove('panel--active');
    document.body.style.overflow = '';
  }

  async updateQuantity(itemKey, quantity) {
    try {
      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          id: itemKey,
          quantity: quantity
        })
      });

      if (!response.ok) {
        throw new Error('Failed to update cart');
      }

      const cart = await response.json();
      await this.refreshCart();
      this.updateCartCount(cart.item_count);

      if (window.notyf) {
        if (quantity === 0) {
          window.notyf.success('Article supprimé du panier');
        } else {
          window.notyf.success('Panier mis à jour');
        }
      }

    } catch (error) {
      console.error('Cart update error:', error);
      if (window.notyf) {
        window.notyf.error('Erreur lors de la mise à jour du panier');
      }
    }
  }

  async refreshCart() {
    try {
      const response = await fetch('/cart?view=drawer');
      if (!response.ok) {
        throw new Error('Failed to fetch cart');
      }

      const html = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');

      const newCartContent = doc.querySelector('[data-cart-drawer-content]');
      if (newCartContent && this.cartContent) {
        this.cartContent.innerHTML = newCartContent.innerHTML;

        this.cartItems = document.querySelector('[data-cart-items]');
        this.cartEmpty = document.querySelector('[data-cart-empty]');
        this.cartFooter = document.querySelector('[data-cart-footer]');
      }

      if (typeof lucide !== 'undefined') {
        lucide.createIcons();
      }

      this.initTermsValidation();

      const cartCountResponse = await fetch('/cart.js');
      const cart = await cartCountResponse.json();
      this.updateCartCount(cart.item_count);

    } catch (error) {
      console.error('Cart refresh error:', error);
    }
  }

  updateCartCount(count) {
    const cartCountElements = document.querySelectorAll('[data-cart-count]');
    cartCountElements.forEach(el => {
      el.textContent = count;
      if (count === 0) {
        el.classList.add('is-hidden');
      } else {
        el.classList.remove('is-hidden');
      }
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new CartDrawer();
});